import * as React from 'react';
import RemoveFacilityOverrideConfirmationDialog from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/ConfirmationDialogs/RemoveFacilityOverrideConfirmationDialog';
import type FacilitiesListView from '@UI/Store/Facilities/Views/FacilitiesListView';
import type FacilityTemplateOverrideView from '@UI/Store/DocumentTemplates/Views/TemplateAssignements/FacilityTemplateOverrideView';
import type DocumentTemplatesListView from '@UI/Store/DocumentTemplates/Views/Document/DocumentTemplatesListView';
import { css } from '@emotion/react';
import { theme } from '@Guidelines/Theme/theme';

const entryStyle = css`
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	flex-wrap: wrap;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly facilities: FacilitiesListView | null;
	readonly facilityOverride: FacilityTemplateOverrideView;
	readonly templates: DocumentTemplatesListView;
	readonly organizationId: number;
};

const TemplateAssignmentOverridesListItem: React.FC<Props> = ({
	templates,
	facilityOverride,
	facilities,
	organizationId,
}) => {
	const facilityName = React.useMemo(() => {
		const facility = facilities?.findById(facilityOverride.facilityId) ?? null;

		if (!facility) {
			return `Agence n° ${facilityOverride.facilityId}`;
		}

		return facility.name;
	}, [facilities, facilityOverride]);

	const templateName = React.useMemo(() => {
		const template = templates.findById(facilityOverride.templateId) ?? null;
		return template !== null ? template.name : '';
	}, [templates, facilityOverride]);

	return (
		<li key={facilityOverride.id} css={entryStyle}>
			<span>
				{facilityName} ({templateName})
			</span>
			<RemoveFacilityOverrideConfirmationDialog
				overrideId={facilityOverride.id}
				organizationId={organizationId}
				facilityName={facilityName}
			/>
		</li>
	);
};

export default TemplateAssignmentOverridesListItem;
